/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this._onClick = null;
      this._onBlockSelect = null;
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.sectionEl = this.closest('.collection-tabs');
        this.links = this.sectionEl ? Array.from(this.sectionEl.querySelectorAll('.linked-to-tab')) : [];
        this.sectionHeader = this.closest('.section-header');
        if (!this.sectionHeader) return;
        this.target = this.dataset.target;
        this.themeScroll = this.sectionHeader.nextElementSibling;

        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(i);
            this.toggleLinks(i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            event.preventDefault();
          });
        });

        if (Shopify.designMode) {
          this._onBlockSelect = (event) => {
            const index = this.buttons.indexOf(event.target);
            if (index !== -1) {
              this.buttons[index].dispatchEvent(new Event('click'));
            }
          };
          this.addEventListener('shopify:block:select', this._onBlockSelect);
        }
      });
    }

    disconnectedCallback() {
      if (this._onBlockSelect) {
        this.removeEventListener('shopify:block:select', this._onBlockSelect);
      }
    }

    toggleButtons(index) {
      this.buttons.forEach((button) => button.classList.remove('active'));
      this.buttons[index].classList.add('active');
    }

    toggleLinks(index) {
      if (this.links.length && this.links[index]) {
        this.links.forEach((link) => link.classList.remove('active'));
        this.links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return;
      const products = slider.querySelectorAll(`.collection-tabs--product:not([data-collection="${handle}"])`);
      const activeProducts = slider.querySelectorAll(`[data-collection="${handle}"]`);

      products.forEach((product) => product.classList.remove('carousel__slide'));
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      if (!this.themeScroll) return;
      this.themeScroll.init();
      const inner = this.themeScroll.querySelector('.theme-scroll--inner');
      if (inner) inner.scroll({ top: 0, left: 0 });
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}